"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.SingleColumnLayout = function (_a) {
    var children = _a.children, _b = _a.fill, fill = _b === void 0 ? true : _b, _c = _a.contain, contain = _c === void 0 ? "boxed" : _c;
    return (react_1.default.createElement(creator_ui_1.Flexbox, { flexDirection: "column", justifyContent: "center", height: fill ? "100%" : "auto", maxWidth: contain === "boxed" ? "960px" : "100%", mx: contain === "boxed" ? "auto" : "initial" }, children));
};
exports.SingleColumnLayout.displayName = "SingleColumnLayout";
